import { useMemo } from 'react';

import { useTeammateAgents } from '@/hooks/useTeammateStudio';
import type { AgentNameById } from '@/components/eval-studio/scenarioStepFormatting';

/** id → name map for humanizing teammate UUIDs in Eval Studio check labels. */
export function useEvalStudioAgentNames(): AgentNameById {
  const { agents } = useTeammateAgents();

  return useMemo(() => {
    const map: AgentNameById = {};
    for (const agent of agents) {
      if (!agent?.id || !agent?.name) continue;
      map[agent.id] = agent.name;
      map[String(agent.id).toLowerCase()] = agent.name;
    }
    return map;
  }, [agents]);
}
